import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {

    loai: null, // string, optional // Phân loại đối tượng được đánh giá
    ten: { // object, optional // Tên nhóm thành phần đánh giá
        vi: null, // string, optional // Tên tiếng Việt
        en: null //string, optional // Tên tiếng Anh
    },
    thu_tu: null, //integer, optional // Thứ tự sắp xếp
    an: null // boolean, optional // Cho biết nhóm thành phần này có đang bị ẩn trên giao diện đánh giá của người dùng hay không

};

// validation form
model.validForm = {

    loai: [ValidService.required], // string, optional // Phân loại đối tượng được đánh giá
    ten: { // object, optional // Tên nhóm thành phần đánh giá
        vi: [], // string, optional // Tên tiếng Việt
        en: [] //string, optional // Tên tiếng Anh
    },
    thu_tu: [], //integer, optional // Thứ tự sắp xếp
    an: [] // boolean, optional // Cho biết nhóm thành phần này có đang bị ẩn trên giao diện đánh giá của người dùng hay không
};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.loaiNhomTPDanhGia = [{
        code: "tour",
        text: "Tour du lịch"
    },
    {
        code: "tour_guide",
        text: "Hướng dẫn viên"
    },
    {
        code: "hq_service",
        text: "Dịch vụ du lịch clc"
    },
    {
        code: "safe_place",
        text: "Điểm đến"
    },
    {
        code: "accommodation",
        text: "Cơ sở lưu trú"
    },
];

model.trangThai = [{
        code: "true",
        text: "Ẩn"
    },
    {
        code: "false",
        text: "Hiện"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thu_tu", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            loai: "",
            thu_tu: "",
            an: []
        },
        valid: {
            loai: [],
            thu_tu: [],
            an: []
        },
        operator: {
            //loai: ":regex:", //:regex:, $vn_text=Viêt nam
            // 'thu_tu':":regex:",
            // 'an':":regex:"
        }
    }
};


export default model;
